import React from "react"

const BlogIndex = () => {
  return (
    <div
      style={{
        backgroundColor: "#0d0d0d",
        color: "#f5f5f5",
        minHeight: "100vh",
        width: "100%",
        margin: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      <h1
        style={{
          fontSize: "4rem",
          margin: 0,
          fontWeight: 700,
          letterSpacing: "0.02em",
        }}
      >
        Games and Theory
      </h1>
    </div>
  )
}

export default BlogIndex
